import * as React from 'react';

const OtpAttempt: React.FC<{
  otpAttempt: string;
  setOtpAttempt: (v: string) => void;
  error: boolean;
}> = ({ otpAttempt, setOtpAttempt, error }) => (
  <input
    aria-label="attempt"
    type="text"
    name="otp_attempt"
    id="otp_attempt"
    value={otpAttempt}
    placeholder="000000"
    required
    minLength={6}
    maxLength={6}
    pattern="\d{6}"
    inputMode="numeric"
    className={`otp-attempt ${error ? 'error' : ''}`}
    onChange={(e) => setOtpAttempt(e.target.value)}
  />
);

export default OtpAttempt;
